import styled from 'styled-components';
import { IPlayButtonWrapperProps } from './PlayButton.types';

export const PlayButtonWrapper = styled.button<IPlayButtonWrapperProps>`
  display: flex;
  flex: 0 0 80px;
  height: 80px;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.showImageBackgroundColor};

  background-image: url(${(props: any) => props.showImageUrl});
  background-size: cover;

  #play {
    circle {
      fill: ${({ theme }) => theme.highlightedColor};
      opacity: 0.85;
      transition:
        fill 0.2s ease,
        stroke 0.2s ease;
    }

    path {
      fill: none;
      stroke: #fff;
      stroke-linecap: round;
      stroke-linejoin: round;
      stroke-width: 2px;
      fill-rule: evenodd;
      transition:
        fill 0.2s ease,
        stroke 0.2s ease;
    }
  }

  &:hover {
    cursor: pointer;
  }

  &.isDisabled:hover {
    cursor: not-allowed;
  }

  #pause {
    circle {
      fill: ${({ theme }) => theme.highlightedColor};
      opacity: 0.85;
      transition:
        fill 0.2s ease,
        stroke 0.2s ease;
    }

    path {
      fill: none;
      stroke: #fff;
      stroke-linecap: round;
      stroke-linejoin: round;
      stroke-width: 2px;
      fill-rule: evenodd;
      transition:
        fill 0.2s ease,
        stroke 0.2s ease;
    }
  }

  &:not(.isDisabled):hover #play,
  &:not(.isDisabled):hover #pause {
    circle {
      fill: #fff;
    }

    path {
      stroke: ${({ theme }) => theme.highlightedColor};
    }
  }
`;
